import React from "react";

import { Carousel, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';





class BootstrapCarouselComponent extends React.Component {
   
    render() {
        return(
            <div class="container-fluid">
                <Row>
                    <Col xs-12='true'>
                        <div style={{
                        backgroundColor: "#113A77",
                        height: "100px",
                        textAlign: "center"}}>
                            <Carousel style={{color:"white", paddingTop:"30px", fontFamily: 'Pangolin, cursive'}} controls={false} indicators={false}>
                                <Carousel.Item>
                                    <h3 style={{color:"white", fontSize:"1em"}}>Livres neufs et d'occasion à petits prix !</h3>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <h3 style={{color:"white", fontSize:"1em"}}>Des bons plans toute l'année !</h3>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <h3 style={{color:"white", fontSize:"1em"}}>Une maison d'édition pas comme les autres !</h3>
                                </Carousel.Item>
                            </Carousel>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default BootstrapCarouselComponent;